export const validateUrl = (url: string): boolean => {
	try {
		return url === new URL(url).href;
	}
	catch {
		return false;
	}
};
